export default class TurnstileWidget {
  static TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
  static TURNSTILE_SITE_KEY = '0x4AAAAAAA-h_DfxL4SML5KU'

  constructor({
    callbackName,
    errorCallbackName,
  }) {
    this.callbackName = callbackName
    this.errorCallbackName = errorCallbackName
  }

  static #loadTurnstile() {
    const script = document.createElement('script')
    script.src = TurnstileWidget.TURNSTILE_SCRIPT_URL
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  createWidgetEl() {
    TurnstileWidget.#loadTurnstile()

    const turnstileHtml = `
      <div 
        class="cf-turnstile" 
        data-sitekey="${TurnstileWidget.TURNSTILE_SITE_KEY}" 
        data-size="normal" 
        data-callback="${this.callbackName}" 
        data-error-callback="${this.errorCallbackName}"
      >
      </div>
    `

    const widget = document.createElement('div')
    widget.id = 'widget-container'
    widget.innerHTML = turnstileHtml
    return widget
  }
}
